import { Api, SecureApi } from 'common/http';
import { buildURLWithQueryString } from 'helpers/UrlHelpers';

// --- Notices

interface GetNoticesParams {
  page?: string,
  slot?: string
}

export const getNotices = async (params: GetNoticesParams) => {
  const { page, slot } = params || {};
  const endpoint = buildURLWithQueryString('/notifications', { page, slot });
  const { data } = await Api.get(endpoint);
  return data;
};

export const getPersonalizedNotices = async (params: GetNoticesParams) => {
  const { page, slot } = params || {};
  const endpoint = buildURLWithQueryString('/notifications', { page, slot });
  const { data } = await SecureApi.get(endpoint);
  return data;
};
